import React from "react"
import DnDBody from "./DnDBody"
import DnDRow from "./DnDRow"
import Content from "./Content"
import DnDText from "./DnDText"
import DnDDivider from "./DnDDivider"
import DnDAvatar from "./DnDAvatar"
import DnDImage from "./DnDImage"
import DnDImageText from "./DnDImageText"
import DnDCarousel from "./DnDCarousel"
import DnDFlatButton from "./DnDFlatButton"
import DnDIconButton from "./DnDIconButton"
import DnDFAButton from "./DnDFAButton"
import DnDProductList from "./DnDProductList"
import DnDYoutube from "./DnDYoutube"
import DnDRowCarousel from "./DnDRowCarousel"
import ContentCarousel from "./ContentCarousel"
import DnDCarouselAnimation from "./DnDCarouselAnimation"
import DnDDealGroupView from "./DnDDealGroupView"
import { connect } from "../../utils"
import "./index.css"

const LayoutHandler = ({ readOnly, ...props }) => {
  if (readOnly) {
  } else {
    const component = dataDnD({ ...props })
    if (component[props.type]) {
      return component[props.type]
    }
  }
}

const dataDnD = ({ ...props }) => {
  return {
    Body: <DnDBody {...props} />,
    RowCarousel: <DnDRowCarousel {...props} />,
    Row: <DnDRow {...props} />,
    ContentCarousel: <ContentCarousel {...props} />,
    Content: <Content {...props} />,
    TextView: <DnDText {...props} />,
    DividerView: <DnDDivider {...props} />,
    AvatarView: <DnDAvatar {...props} />,
    ImageView: <DnDImage {...props} />,
    ImageTextView: <DnDImageText {...props} />,
    CarouselView: <DnDCarousel {...props} />,
    FlatButtonView: <DnDFlatButton {...props} />,
    IconButtonView: <DnDIconButton {...props} />,
    FAButtonView: <DnDFAButton {...props} />,
    ProductListView: <DnDProductList {...props} />,
    YoutubeView: <DnDYoutube {...props} />,
    CarouselAnimationView: <DnDCarouselAnimation {...props} />,
    DealGroupView: <DnDDealGroupView {...props} />,
  }
}

export default connect("readOnly")(LayoutHandler)



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/index.js